/**
 * CR500 Phase 2A: DetailsPillsBlock
 * 
 * Renders the discount tiers/details pills section.
 * Extracted from DealGiftCard for v2 block-based rendering.
 */

import React from "react";
import type { DealCardBlockProps } from "@/lib/deal-cards/specV2/types";
import type { Deal } from "@/lib/types/deals";
import { formatDiscountTiers, isBulkDeal } from "@/lib/types/deals";

interface DetailsPillsBlockProps extends DealCardBlockProps<Deal> {
  /** Pre-computed discount tiers (optional - will compute if not provided) */
  discountTiers?: string[];
}

export const DetailsPillsBlock: React.FC<DetailsPillsBlockProps> = ({
  deal,
  block,
  context,
  discountTiers: discountTiersProp,
}) => {
  // Don't render if block is disabled
  if (!block.enabled) {
    return null;
  }

  // Compute discount tiers if not provided
  const discountTiers = discountTiersProp ?? formatDiscountTiers(deal);
  const bulkDeal = isBulkDeal(deal);
  
  // Only render if we have tiers
  if (discountTiers.length === 0) {
    return null;
  }

  return (
    <div 
      className="mt-2 space-y-1 text-sm text-black/70 bg-black/5 rounded-lg p-3"
      data-block="details_pills"
      data-block-id={block.id}
      data-component-key="details_pills"
    >
      {discountTiers.map((tier, idx) => (
        <p key={idx}>{tier}</p>
      ))}
      {bulkDeal && <p className="text-xs font-medium text-black/60 mt-1">Bulk deal</p>}
    </div>
  );
};

export default DetailsPillsBlock;
